import React from 'react';
import { useSelector } from 'react-redux';
import { CellInfo } from 'react-table';

import { ViewFrame, ListTable } from '../../components';
import { useTitle, useActionDispatcher } from '../../hooks';
import {
  deleteVideoMenuRequest,
  getVideoMenuListRequest,
  setVideoMenuListDirty,
} from '../../store/modules/video-menus/actions';
import { selectVideoMenusList } from '../../store/modules/video-menus/selectors';
import DeleteAction from '../../components/action/DeleteAction';
import DuplicateAction from './actions/duplicateAction';
import AdvancedActionCell from '../../components/action-cell/AdvancedActionCell';

const title = 'Video Menus';

const VideoMenuList = () => {
  useTitle(title);

  const { loading, data, dirty } = useSelector(selectVideoMenusList);

  const getVideoMenuList = useActionDispatcher(getVideoMenuListRequest);
  const setDirty = useActionDispatcher(setVideoMenuListDirty);
  const deleteVideoMenu = useActionDispatcher(deleteVideoMenuRequest);

  return (
    <ViewFrame title={title}>
      <ListTable
        columns={[
          {
            id: 'title',
            Header: 'Title',
          },
          {
            id: 'ref.updated_age',
            Header: 'Last Update',
            width: 110,
          },
          {
            id: 'ref.user.full_name_first_last',
            Header: 'Owner',
            width: 130,
          },
          {
            id: 'ref.organization.common_name',
            Header: 'Organization',
            width: 130,
          },
          {
            id: 'actions',
            accessor: 'id',
            Cell: (cell: CellInfo) => (
              <AdvancedActionCell>
                {
                  cell.original.permissions.can_view
                  && <DuplicateAction original={cell.original} />
                }
                {
                  cell.original.permissions.can_delete
                  && <DeleteAction {...cell} onDelete={deleteVideoMenu} />
                }
              </AdvancedActionCell>
            ),
            width: 65,
          },
        ]}
        loading={loading}
        data={data}
        fetch={getVideoMenuList}
        dirty={Boolean(dirty)}
        setDirty={setDirty}
      />
    </ViewFrame>
  );
};

export default VideoMenuList;
